import Vue from 'vue';
export default Vue.extend({
    name: 'letDeleteFolderPopupChunk',
    props: {
        slotData: {
            required: true
        }
    }
});
